import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useParams, useLocation } from 'react-router-dom';

import { getContact, updateContact } from '../../api/contacts';
import { TemplateField } from '../../components/Attributes/Attributes_old';
import {
	classNames,
	getUserFullName,
} from '../../components/helpers/functions';
import ProtectedRoute from '../../components/helpers/ProtectedRoute';

import { List, ListItem } from '../../components/List';
import { AvatarGenerated } from '../../components/Avatar';
import Button from '../../components/Button';
import LoadingSkeleton from '../../components/Shell/LoadingSkeleton';
import useAsync from '../../hooks/useAsync';

const getTitle = ({ type, title, company, location }) => {
	if (type === 'person') {
		if (company && title) {
			return `${title} at ${company.companyName}`;
		} else if (company && !title) {
			return `from ${company.companyName}`;
		} else if (!company && title) {
			return title;
		}
	} else if (type === 'company') {
		if (location) {
			return `${location && ` from ${location}`}`;
		}
		return null;
	}
	return null;
};

const AssetsTab = ({}) => {
	return (
		<div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8">
			<div className="flex justify-end">
				<Button type="secondary">Add Asset</Button>
			</div>
			<List>
				<ListItem>Testing</ListItem>
				<ListItem>Testing</ListItem>
				<ListItem>Testing</ListItem>
				<ListItem>Testing</ListItem>
			</List>
		</div>
	);
};

export const ActualProfile = () => {
	const { id, tab } = useParams();

	const {
		value: contact,
		execute: getSingleContact,
		status: loadingContact,
	} = useAsync(getContact, { immediate: false });

	const { execute: onUpdateContact, status: isUpdating } = useAsync(
		updateContact,
		{ immediate: false },
	);

	useEffect(() => {
		if (id) {
			getSingleContact({ id });
		}
	}, [id]);
	const navigate = useNavigate();
	return (
		<>
			<div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8">
				<dl className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
					{/*[
						{ field: 'Email', dataIndex: 'email' },

						{
							field: 'Phone',
							dataIndex: 'phoneNumber',
						},
						{ field: 'Location', dataIndex: 'location' },
					]
						.filter(({ dataIndex }) => contact[dataIndex])
						.map(({ field, dataIndex }) => (
							<TemplateField
								span="sm:col-span-1"
								name={field}
								value={contact[dataIndex]}
								isEditing={false}
							/>
						))*/}
				</dl>
			</div>

			{/* Team member list */}
			{contact?.team?.length ? (
				<div className="mx-auto mt-8 max-w-5xl px-4 pb-12 sm:px-6 lg:px-8">
					<h2 className="text-sm font-medium text-gray-500 mb-3">
						{contact?.type === 'company'
							? `Team members`
							: `Team members at ${contact?.company?.companyName}`}
					</h2>
					<div className="mt-1 grid grid-cols-1 gap-4 sm:grid-cols-2">
						{contact?.team?.map((person) => (
							<div
								key={person.id}
								className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-pink-500 focus-within:ring-offset-2 hover:border-gray-400"
							>
								<div className="min-w-0 flex-1">
									<a
										onClick={() => navigate(`/manage/directory/${person.id}`)}
										className="focus:outline-none cursor-pointer"
									>
										<div className="flex items-center">
											<AvatarGenerated
												type={person.type}
												id={getUserFullName(person)}
												size="xs"
											/>
											<div className="ml-3">
												<span className="absolute inset-0" aria-hidden="true" />
												<p className="text-sm font-medium text-gray-900">
													{getUserFullName(person)}
												</p>
												<p className="truncate text-sm text-gray-500">
													{getTitle(person)}
												</p>
											</div>
										</div>
									</a>
								</div>
							</div>
						))}
					</div>
				</div>
			) : null}
		</>
	);
};

export default () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const location = useLocation();

	const allTabs = location?.pathname?.split('/');
	const currentTab = allTabs[allTabs.length - 1];

	const [openSlider, setOpenSlider] = useState(false);

	const {
		value: contact,
		execute: getSingleContact,
		status: loadingContact,
	} = useAsync(getContact, { immediate: false });

	const { execute: onUpdateContact, status: isUpdating } = useAsync(
		updateContact,
		{ immediate: false },
	);

	useEffect(() => {
		if (id) {
			getSingleContact({ id });
			setOpenSlider(true);
		}
	}, [id]);

	return (
		<>
			{loadingContact === 'pending' && !contact ? (
				<LoadingSkeleton />
			) : contact ? (
				<main className="relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last hidden xl:flex xl:flex-col">
					<article>
						{/* Profile header */}
						<div>
							<div className="hidden mx-auto max-w-5xl px-4 sm:px-6 lg:px-8  xl:flex xl:flex-col">
								<div className="mt-6 hidden min-w-0 flex-1 sm:block">
									<AvatarGenerated
										id={
											contact?.type === 'company'
												? contact.id
												: getUserFullName(contact)
										}
										type={contact?.type}
										size="xl"
									/>
									<h1 className="truncate text-2xl font-bold text-gray-900 mt-4">
										{contact?.type === 'company'
											? contact?.companyName
											: getUserFullName(contact)}
									</h1>
									<div className="text-gray-500 text-sm mt-1">
										{getTitle(contact)}
									</div>
								</div>
							</div>
						</div>

						{/* Tabs */}
						<div className="mt-6 sm:mt-2 2xl:mt-5">
							<div className="border-b border-gray-200">
								<div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
									<nav className="-mb-px flex space-x-8" aria-label="Tabs">
										{[
											{
												name: 'Profile',
												onClick: () =>
													navigate(`/manage/directory/${contact.id}`),
												current: currentTab !== 'assets',
											},
											/*
											...(contact?.type === 'company'
												? [
														{
															name: 'Assets',
															onClick: () =>
																navigate(
																	`/manage/directory/${contact.id}/assets`
																),
															current: currentTab === 'assets',
														},
												  ]
												: []),*/
											{
												name: 'Edit',
												onClick: () =>
													navigate(`/manage/directory/${contact.id}/edit`),
											},
										].map((tab) => (
											<a
												key={tab.name}
												onClick={() =>
													typeof tab.onClick === 'function' ? tab.onClick() : {}
												}
												className={classNames(
													tab.current
														? 'border-pink-500 text-gray-900'
														: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
													'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
													tab.danger
														? ' text-red-400 hover:text-red-600 hover:border-none'
														: '',
												)}
												aria-current={tab.current ? 'page' : undefined}
											>
												{tab.name}
											</a>
										))}
									</nav>
								</div>
							</div>
						</div>

						{/*<Routes>
							<ProtectedRoute
								exact
								path={`/manage/directory/:id`}
								component={() => <ActualProfile contact={contact} />}
							/>
							{/*contact?.type === 'company' && (
								<ProtectedRoute
									exact
									path={`/manage/directory/:id/assets`}
									component={() => <AssetsTab />}
								/>
							)
						</Routes>*/}
					</article>
				</main>
			) : (
				<div className="text-xs text-gray-500 text-center pt-12">
					Select a contact
				</div>
			)}
		</>
	);
};
